import React from "react";
import PropTypes from "prop-types";
import {isFormSubmittable, setFormState, getFormInputCssClass, hasMessage} from "../../../util/FormUtil";
import validator from "validator";
import {isNotBlank} from "../../../util/StringUtil";

const BASE_INPUT_CSS = "text-input text-input--large";
const PROP_NAME_NEW_EMAIL = "newEmail";
const PROP_NAME_CONF_NEW_EMAIL = "confirmNewEmail";

class UpdateEmailComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {data: {}, metadata: {}};
        this.setFormState = this.setFormState.bind(this);
        this.setNewEmail = this.setNewEmail.bind(this);
        this.setConfirmNewEmail = this.setConfirmNewEmail.bind(this);
        this.setProperty = this.setProperty.bind(this);
        this.validate = this.validate.bind(this);
        this.updateEmail = this.updateEmail.bind(this);
    }

    setFormState(...args) {
        // we are taking updater function in setState so that successive setState calls won't overwrite each other.
        this.setState(state => setFormState(state, args));
    }

    setNewEmail(e) {
        this.setProperty(PROP_NAME_NEW_EMAIL, e);
    }

    setConfirmNewEmail(e) {
        this.setProperty(PROP_NAME_CONF_NEW_EMAIL, e);
    }

    setProperty(propertyName, e){
        const data = e.target.value;
        this.setState(state => setFormState(state, [{property: propertyName, data, metadata: {dirty: true}}]), this.validate);
    }

    validate() {
        const {data, metadata} = this.state;
        const email = this.props.email ? this.props.email.trim().toLowerCase() : "";
        const newEmail = data[PROP_NAME_NEW_EMAIL] ? data[PROP_NAME_NEW_EMAIL].trim().toLowerCase() : "";
        const confirmNewEmail = data[PROP_NAME_CONF_NEW_EMAIL] ? data[PROP_NAME_CONF_NEW_EMAIL].trim().toLowerCase() : "";
        const isEmailValid = newEmail && newEmail !== email && validator.isEmail(newEmail);
        const isConfirmNewEmailValid = confirmNewEmail && newEmail === confirmNewEmail;
        const newEmailMessage = isEmailValid ? null :
            (
                isNotBlank(newEmail) ?
                    (email === newEmail ? "The new email must be different from the original email." : "The email you entered is not valid.") :
                    "Email is required."
            );
        const newConfirmEmailMessage = isConfirmNewEmailValid ? null : (isNotBlank(confirmNewEmail) ? "Confirm email must be the same as email." : "Confirm email is required.");
        const newEmailMeta = metadata[PROP_NAME_NEW_EMAIL] ? metadata[PROP_NAME_NEW_EMAIL] : {};
        const confirmNewEmailMeta = metadata[PROP_NAME_CONF_NEW_EMAIL] ? metadata[PROP_NAME_CONF_NEW_EMAIL] : {};

        this.setFormState(
            {
                property: PROP_NAME_NEW_EMAIL,
                metadata: {...newEmailMeta, valid: isEmailValid, message: newEmailMessage}
            },
            {
                property: PROP_NAME_CONF_NEW_EMAIL,
                metadata: {...confirmNewEmailMeta, valid: isConfirmNewEmailValid, message: newConfirmEmailMessage}
            });
    }

    updateEmail() {
        const {verificationEmailSender} = this.props;
        const {data} = this.state;
        const email = data[PROP_NAME_NEW_EMAIL];
        verificationEmailSender(email);
    }

    render() {
        const {email, onCancel} = this.props;
        const {data, metadata} = this.state;
        const newEmail = data[PROP_NAME_NEW_EMAIL];
        const confirmNewEmail = data[PROP_NAME_CONF_NEW_EMAIL];
        const valid = isFormSubmittable(metadata);
        const newEmailCss = BASE_INPUT_CSS + getFormInputCssClass(metadata, "newEmail");
        const confirmNewEmailCss = BASE_INPUT_CSS + getFormInputCssClass(metadata, "confirmNewEmail");
        const showEmailMessage = hasMessage(metadata, PROP_NAME_NEW_EMAIL);
        const showConfEmailMessage = hasMessage(metadata, PROP_NAME_CONF_NEW_EMAIL);
        return (
            <div>
                <h1>Update email</h1>
                <div>
                    You indicated that <strong>{email}</strong> is not the correct email. Please enter the correct
                    email below:
                </div>
                <ul className="form-fields grid">
                    <li className="push--top grid__col-md-8 grid__col-sm-12 hard--sides">
                        <label htmlFor="email">Email</label>
                        <input id="email" type="email" className={newEmailCss} value={newEmail}
                               onChange={this.setNewEmail}/>
                        {
                            showEmailMessage &&
                            <div className="error">{metadata[PROP_NAME_NEW_EMAIL].message}</div>
                        }

                    </li>
                    <li className="grid__col-md-8 grid__col-sm-12  hard--sides">
                        <label htmlFor="confirmEmail">Confirm Email</label>
                        <input id="confirmEmail" type="email" className={confirmNewEmailCss} value={confirmNewEmail}
                               onChange={this.setConfirmNewEmail}/>
                        {
                            showConfEmailMessage &&
                            <div className="error">{metadata[PROP_NAME_CONF_NEW_EMAIL].message}</div>
                        }
                    </li>
                </ul>
                <div>
                    <button className="btn btn--outline btn--large" onClick={onCancel}>Cancel</button>
                    <button className="btn btn--large push--left" disabled={!valid} onClick={this.updateEmail}>Update &amp; Re-send
                        verification email
                    </button>
                </div>
            </div>
        );
    }
}

UpdateEmailComponent.propTypes = {
    email: PropTypes.string.isRequired,
    verificationEmailSender: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default UpdateEmailComponent;